var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapValveSoftenerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 197,
    viewBox: "0 0 209 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OFF",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811",
    transform: "translate(24.03 169.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M31.8,197a7.785,7.785,0,0,1-7.77-7.79V172.57a2.59,2.59,0,1,1,5.18,0v16.641a2.6,2.6,0,0,0,2.59,2.6h0l174.6-.17h0a2.6,2.6,0,0,1,0,5.2Z",
    transform: "translate(-24.03 -169.98)",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(23.68 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M26.27,113.246a2.593,2.593,0,0,1-2.59-2.6V2.6a2.59,2.59,0,1,1,5.18,0V110.656a2.591,2.591,0,0,1-2.59,2.59Z",
    transform: "translate(-23.68 -0.01)",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816",
    transform: "translate(15.98 15.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813",
    transform: "translate(1.22 0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M17.2,38.611l7.43-11.041L17.2,16.53H35.34l-7.43,11.041,7.43,11.041Z",
    transform: "translate(-17.2 -16.53)",
    fill: "#2f323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M34.13,17.17,30.2,23l-3.07,4.56,3.07,4.56,3.93,5.83H18.43l3.93-5.83,3.07-4.56L22.36,23l-3.93-5.83h15.7m2.43-1.29H15.98l1.36,2.03,3.93,5.83,2.58,3.83L21.27,31.4l-3.93,5.83-1.36,2.03H36.56L35.2,37.231l-3.93-5.83-2.58-3.83,2.58-3.83,3.93-5.83Z",
    transform: "translate(-15.98 -15.88)",
    fill: "#6a7084"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861",
    transform: "translate(0 110.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817",
    transform: "translate(9.308 14.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M42.811,124.99v40.2a5.354,5.354,0,0,1-5.17,5.51H15.78a5.347,5.347,0,0,1-5.17-5.51v-40.2",
    transform: "translate(-9.308 -124.99)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M37.64,172H15.78a6.649,6.649,0,0,1-6.47-6.81v-40.2H11.9v40.2a4.06,4.06,0,0,0,3.88,4.21H37.64a4.06,4.06,0,0,0,3.88-4.21v-40.2h2.59v40.2A6.656,6.656,0,0,1,37.64,172Z",
    transform: "translate(-9.308 -124.99)",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858",
    transform: "translate(15.41 19.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819",
    transform: "translate(0.88 31.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M17.59,162.85a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,17.59,162.85Z",
    transform: "translate(-16.29 -160.25)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821",
    transform: "translate(6.35 28.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M23.06,160.38a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-21.76 -157.78)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823",
    transform: "translate(11.291 32.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M28,163.74a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-26.7 -161.14)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825",
    transform: "translate(16.76 27.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M33.47,159.67a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,33.47,159.67Z",
    transform: "translate(-32.17 -157.07)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827",
    transform: "translate(20.64 31.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M37.35,163.56a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,37.35,163.56Z",
    transform: "translate(-36.05 -160.96)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829",
    transform: "translate(20.999 22.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M37.71,154a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-36.41 -151.4)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831",
    transform: "translate(13.06 22.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M29.77,154.18a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,29.77,154.18Z",
    transform: "translate(-28.47 -151.58)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9833",
    "data-name": "Group 9833",
    transform: "translate(6.7 21.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M23.41,152.76a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-22.11 -150.16)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835",
    transform: "translate(1.409 22.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M18.12,154.18a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,18.12,154.18Z",
    transform: "translate(-16.82 -151.58)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837",
    transform: "translate(3.7 14.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9836",
    "data-name": "Group 9836",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M20.41,145.86a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-19.11 -143.26)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839",
    transform: "translate(10.941 10.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M27.65,141.97a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,27.65,141.97Z",
    transform: "translate(-26.35 -139.37)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841",
    transform: "translate(10.941 16.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M27.65,148.52a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,27.65,148.52Z",
    transform: "translate(-26.35 -145.92)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843",
    transform: "translate(16.94 16.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M33.65,148.16a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-32.35 -145.56)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845",
    transform: "translate(19.94 11.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M36.65,142.85a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,36.65,142.85Z",
    transform: "translate(-35.35 -140.25)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847",
    transform: "translate(0.88 7.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M17.59,139.49a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,17.59,139.49Z",
    transform: "translate(-16.29 -136.89)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849",
    transform: "translate(6.7 3.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9848",
    "data-name": "Group 9848",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M23.41,134.71a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-22.11 -132.11)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9851",
    "data-name": "Group 9851",
    transform: "translate(14.999 4.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9850",
    "data-name": "Group 9850",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M31.71,136.66a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,31.71,136.66Z",
    transform: "translate(-30.41 -134.06)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9853",
    "data-name": "Group 9853",
    transform: "translate(19.409 0.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9852",
    "data-name": "Group 9852",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M36.12,132.59a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-34.82 -129.99)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9855",
    "data-name": "Group 9855",
    transform: "translate(11.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9854",
    "data-name": "Group 9854",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M28.53,131.7a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,28.53,131.7Z",
    transform: "translate(-27.23 -129.1)",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M16.71,131.7a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,16.71,131.7Z",
    transform: "translate(-15.41 -129.1)",
    fill: "#6a7084"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859",
    transform: "translate(17.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M18.03,121.261v-5.75a5.181,5.181,0,0,1,5.17-5.19h7a5.175,5.175,0,0,1,5.17,5.19v5.75",
    transform: "translate(-17.711 -110)",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M35.71,121.261h-.65v-5.75a4.863,4.863,0,0,0-4.85-4.86h-7a4.863,4.863,0,0,0-4.85,4.86v5.75h-.65v-5.75a5.512,5.512,0,0,1,5.5-5.51h7a5.512,5.512,0,0,1,5.5,5.51Z",
    transform: "translate(-17.711 -110)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860",
    transform: "translate(0 7.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M0,125.42H45.37a2.868,2.868,0,0,0,2.86-2.87v-1.51a2.862,2.862,0,0,0-2.86-2.87H0",
    transform: "translate(0 -117.84)",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M45.37,125.75H0v-.65H45.37a2.546,2.546,0,0,0,2.54-2.55v-1.51a2.552,2.552,0,0,0-2.54-2.55H0v-.65H45.37a3.2,3.2,0,0,1,3.19,3.2v1.51a3.2,3.2,0,0,1-3.19,3.2Z",
    transform: "translate(0 -117.84)",
    fill: "#404041"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapValveSoftenerOff);
export default __webpack_public_path__ + "static/media/air_gap_valve_softener_off.80a8a625d232612a7b956e5bfd9c2b0b.svg";
export { ForwardRef as ReactComponent };